import React from 'react';
import { connect } from 'react-redux';
import { updateIntl } from 'react-intl-redux';
import getMessages from '../../lib/i18n/getMessages';
import { isEmpty } from 'lodash';

const mapStateToProps = state => ({
  currentLocale : state.intl.locale,
  store         : state,
});

const mapDispatchToProps = dispatch => ({
  changeLocale : e =>
    dispatch(
      updateIntl({
        locale   : e.target.value.toLowerCase(),
        messages : getMessages(e.target.value.toLowerCase()),
      })
    ),
});

const SwitchLocale = ({ currentLocale, locales, store, changeLocale, updateAction }) => {
  if (isEmpty(locales) || locales.length < 2) return <span />;
  return (
    <select
      className="form-control"
      value={currentLocale.toUpperCase()}
      onChange={e => {
        changeLocale(e);
        const selectedLocale = e.target.value.toLowerCase();
        updateAction({ locale: selectedLocale });
        if (selectedLocale === 'fr') {
          const logo = document.querySelector('.logo img');
          logo.src = logo.src.replace('.png', '_FR.png');
        } else {
          const logo = document.querySelector('.logo img');
          logo.src = logo.src.replace('_FR', '');
        }
        window.intercomSettings = {
          ...window.intercomSettings,
          language_override : selectedLocale,
        };
        Intercom('boot', window.intercomSettings);
      }}>
      {locales.map(locale => <option key={locale} value={locale}>{locale.toUpperCase()}</option>)}
    </select>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchLocale);
